/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Phoenix | v1
 * OpenAPI spec version: 1.0.0
 */

export type TransportSchemeKind = typeof TransportSchemeKind[keyof typeof TransportSchemeKind];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TransportSchemeKind = {
  Air: 'Air',
  Bus: 'Bus',
  AirBus: 'AirBus',
  BusAir: 'BusAir',
} as const;
